import axios from "axios";
import { logout } from "../lib/auth";

import { CONST } from "../config/const";

// 検索用 - 上位店一覧取得
export async function getSerchHighRankCompanys() {
  try {
    const path = "serch/highRankCompanys";
    const response = await axios.get(CONST.apiUrl2 + path);
    if (response.data.fetch_data === "null") {
      return null;
    }
    return { highRankCompanys: response.data.fetch_data };
  } catch (error) {
    // logout();
  }
}

// 検索用 - 商材一覧取得
export async function getSerchProducts() {
  try {
    const path = "serch/products";
    const response = await axios.get(CONST.apiUrl2 + path);
    if (response.data.fetch_data === "null") {
      return null;
    }
    return { products: response.data.fetch_data };
  } catch (error) {
    // logout();
  }
}

// 検索用 - 商材一覧取得
export async function getSerchCategorys() {
  try {
    const path = "serch/categorys";
    const response = await axios.get(CONST.apiUrl2 + path);
    if (response.data.fetch_data === "null") {
      return null;
    }
    return { categorys: response.data.fetch_data };
  } catch (error) {
    // logout();
  }
}

// 検索用 - パートナー一覧取得
export async function getSerchSaleCompanys() {
  try {
    const path = "serch/saleCompanys";
    const response = await axios.get(CONST.apiUrl2 + path);
    if (response.data.fetch_data === "null") {
      return null;
    }
    return { saleCompanys: response.data.fetch_data };
  } catch (error) {
    // logout();
  }
}

// 検索用 - パートナー一覧取得
export async function getSerchSaleCompanyGroups() {
  try {
    const path = "serch/saleCompanyGroups";
    const response = await axios.get(CONST.apiUrl2 + path);
    if (response.data.fetch_data === "null") {
      return null;
    }
    return { saleCompanyGroups: response.data.fetch_data };
  } catch (error) {
    // logout();
  }
}

// スタッフアカウント一覧取得
export async function getSerchAccountStaffs() {
  try {
    const path = "serch/account/staffs";
    const response = await axios.get(CONST.apiUrl2 + path);
    if (response.data.fetch_data === "null") {
      return null;
    }
    return { accountStaffs: response.data.fetch_data };
  } catch (error) {
    // logout();
  }
}
// 営業アカウント一覧取得
export async function getSerchAccountSales() {
  try {
    const path = "serch/account/sales";
    const response = await axios.get(CONST.apiUrl2 + path);
    if (response.data.fetch_data === "null") {
      return null;
    }
    return { accountSales: response.data.fetch_data };
  } catch (error) {
    // logout();
  }
}
// 協業パートナー営業アカウント一覧取得
export async function getSerchAccountCollaborateCompanys() {
  try {
    const path = "serch/account/collaborateCompanySales";
    const response = await axios.get(CONST.apiUrl2 + path);
    if (response.data.fetch_data === "null") {
      return null;
    }
    return { accountCollaborateCompanySales: response.data.fetch_data };
  } catch (error) {
    // logout();
  }
}

// 明細出力用 - 代理店-独自単価一覧取得
export async function getSerchSaleCompanyUniquePayments(id: number) {
  try {
    const path = "serch/saleCompanyUniquePayments";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    return { saleCompanyUniquePayments: response.data.fetch_data };
  } catch (error) {
    // logout();
  }
}

// 外部エントリーサイトのパス一覧取得
export async function getSerchSitePaths() {
  try {
    const path = "serch/sitePaths";
    const response = await axios.get(CONST.apiUrl2 + path);
    if (response.data.fetch_data === "null") {
      return null;
    }
    return { sitePaths: response.data.fetch_data };
  } catch (error) {
    // logout();
  }
}
